export default (state = [], action) => {
    switch (action.type) {
        case 'FETCH_ACTIVE_USERS_LIST_DATA':
            return action.payload;
        default:
            return state;
    }
};